// extracted by mini-css-extract-plugin
module.exports = {"nextStepsTable":"styles_nextStepsTable__w5JQO","loadingState":"styles_loadingState__2GJkj","slideInFromRight":"styles_slideInFromRight__3g2bz"};